function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M21,0H2.46A2.46,2.46,0,0,0,0,2.46V16.14A2.46,2.46,0,0,0,2.46,18.6H21a2.46,2.46,0,0,0,2.46-2.46V2.46A2.46,2.46,0,0,0,21,0ZM2.46,1H21a1.46,1.46,0,0,1,1.46,1.46V4.89H1V2.46A1.46,1.46,0,0,1,2.46,1ZM21,17.6H2.46A1.46,1.46,0,0,1,1,16.14V5.89H22.49V16.14A1.46,1.46,0,0,1,21,17.6ZM3.43,3A.58.58,0,0,1,4.58,3,.58.58,0,0,1,3.43,3Zm2.5,0A.57.57,0,1,1,7.07,3,.57.57,0,0,1,5.93,3ZM8.42,3A.58.58,0,1,1,9,3.6.58.58,0,0,1,8.42,3Z"
})));

var SvgHostedPayments = function SvgHostedPayments(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.49 18.6",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHostedPayments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hosted-payments.bd5f1efb.svg";
export { ForwardRef as ReactComponent };